import * as React from "react";

function PrivacyPolicyDe() {
  return (
    <div>
      <section className="content">
        {/* <h2>OUR DATA PROTECTION POLICY</h2> */}
        {/* <hr /> */}
        <h3>Datenschutz</h3>
        <p>
          Wir nehmen den Schutz Ihrer persönlichen Daten sehr ernst. Wir
          behandeln Ihre Personendaten vertraulich und entsprechend der
          gesetzlichen Datenschutzvorschriften sowie dieser
          Datenschutzerklärung. Personendaten werden auf dieser Website nur im
          notwendigen Umfang erhoben und verarbeitet. Die nachfolgende Erklärung
          gibt Ihnen einen Überblick darüber, wie wir diesen Schutz
          gewährleisten und welche Art von Daten zu welchem Zweck erhoben
          werden.
        </p>
        <hr />
        <h3>Name und Anschrift der verantwortlichen Stelle</h3>
        <p>Verantwortliche Stelle im Sinne der Datenschutzgesetzgebung ist:</p>
        <p>
          Arbonia AG <br /> Amriswilerstrasse 50 <br /> 9320 Arbon <br />{" "}
          Switzerland
        </p>
        <p>
          T +41 71 447 41 41 <br /> holding@arbonia.com
        </p>
        <hr />
        <h3>1. Personendaten</h3>
        <p>
          Wenn Sie diese Website benutzen, werden verschiedene Personendaten
          erhoben. Personendaten sind Daten, mit denen Sie persönlich
          identifiziert werden können.{" "}
        </p>
        <p>
          Jederzeit haben Sie das Recht, im Rahmen der geltenden gesetzlichen
          Bestimmungen Informationen über Ihre gespeicherten personenbezogenen
          Daten, deren Herkunft sowie die Empfänger und den Zweck der
          Datenverarbeitung zu erhalten. Falls rechtliche Voraussetzungen
          vorliegen, haben Sie das Recht auf Berichtigung oder Löschung Ihrer
          personenbezogenen Daten, die Einschränkung ihrer Verarbeitung, das
          Widerspruchsrecht gegen die Verarbeitung sowie das Recht auf
          Datenübertragbarkeit.
        </p>
        <p>
          Wenn Sie Ihre Einwilligung zur Verarbeitung Ihrer personenbezogenen
          Daten durch uns erteilt haben, haben Sie das Recht, die Einwilligung
          jederzeit zu widerrufen. Die Rechtmäßigkeit der Verarbeitung Ihrer
          personenbezogenen Daten vor dem Widerruf bleibt vom Widerruf
          unberührt. Die weitere Verarbeitung von Daten auf einer anderen
          rechtlichen Grundlage, wie z. B. zur Erfüllung gesetzlicher
          Verpflichtungen, bleibt von diesem Widerruf unbeeinträchtigt.
        </p>
        <p>
          Wenn Sie der Ansicht sind, dass die Verarbeitung Ihrer
          personenbezogenen Daten durch uns gegen das geltende Datenschutzrecht
          verstößt, haben Sie das Recht, sich bei den zuständigen Behörden zu
          beschweren.{" "}
        </p>
        <hr />
        <h3>2. Erfassung und Verarbeitung von Personendaten</h3>
        <h5>a) Bei Besuch unserer Website</h5>
        <p>
          Wenn Sie unsere Website besuchen, verarbeiten wir Daten, die Ihr
          Browser automatisch an uns übermittelt. Dies Daten umfassen Ihre
          IP-Adresse, Uhrzeit der Serveranfrage, Browsertyp und Browserversion,
          verwendetes Betriebssystem, Referrer-URL, Hostname des zugreifenden
          Rechners. Personendaten über die Nutzung unserer Website verarbeiten
          wir nur, soweit dies erforderlich ist, um dem Nutzer die
          Inanspruchnahme des Dienstes zu ermöglichen.
        </p>
        <p>
          Die Erhebung und Verarbeitung dieser Daten erfolgt zu internen
          statistischen Zwecken. Grundlage für die Datenverarbeitung sind die
          Verarbeitung von Daten zur Erfüllung eines Vertrags oder
          vorvertraglicher Massnahmen. Weitere Grundlage für die
          Datenverarbeitung ist unser berechtigtes Interesse, die Daten zu
          verarbeiten, um die Stabilität und Sicherheit der Website zu
          gewährleisten.
        </p>
        <p>
          Teilweise verwenden wir auch Cookies. Cookies sind kleine Textdateien,
          die auf Ihrem Rechner abgelegt werden und die Ihr Browser speichert.
          Sie dienen dazu, unser Angebot nutzerfreundlicher, effektiver und
          sicherer zu machen. Die meisten der von uns verwendeten Cookies sind
          so genannte „Session-Cookies“. Sie werden nach Ende Ihres Besuchs
          automatisch gelöscht. Cookies richten auf Ihrem Rechner keinen Schaden
          an und enthalten keine Viren. Sie haben die Möglichkeit, diese
          Funktion in Ihrem Browser zu deaktivieren oder die Einstellungen
          anzupassen, so dass Sie in individuellen Fällen entscheiden können, ob
          ein Cookie akzeptiert werden soll oder nicht. In diesem Fall kann
          jedoch die Benutzerfreundlichkeit unserer Website eingeschränkt sein.
          Cookies, die zur Durchführung des elektronischen
          Kommunikationsverfahrens oder zur Bereitstellung bestimmter Funktionen
          (z. B. die Funktion des Warenkorbs) erforderlich sind, werden aufgrund
          unseres berechtigten Interesses an der Speicherung von Cookies
          gespeichert, um sicherzustellen, dass wir unsere Dienstleistungen in
          optimierter und technisch fehlerfreier Weise bereitstellen.{" "}
        </p>

        <h5>b) Bei Benützung eines Kontaktformulars/Zusendung einer E-Mail</h5>
        <p>
          Wenn Sie Anfragen an uns senden, werden Ihre Angaben im
          Anfrageformular sowie jegliche Kontaktinformationen, die Sie
          bereitstellen, von uns zu dem Zweck gespeichert, Ihre Anfrage zu
          bearbeiten und etwaige Folgefragen zu klären. Wir geben die Daten ohne
          Ihre Zustimmung nicht an Dritte weiter.
        </p>
        <p>
          Die Verarbeitung Ihrer Daten erfolgt auf Grundlage Ihrer Einwilligung.
          Sie können diese Einwilligung jederzeit widerrufen. Hierzu genügt eine
          formlose Mitteilung per E-Mail an uns. Die Rechtmäßigkeit der bis zum
          Widerruf durchgeführten Datenverarbeitung bleibt vom Widerruf
          unberührt.
        </p>
        <p>
          Ihre Daten verbleiben bei uns, bis Sie die Löschung beantragen, Ihre
          Einwilligung zur Speicherung der Daten widerrufen oder der Zweck für
          die Datenspeicherung nicht mehr besteht (z. B. nach Bearbeitung Ihrer
          Anfrage). Gesetzliche Aufbewahrungsfristen bleiben hiervon unberührt.
        </p>
        <h5>c)Datenverarbeitung im Bewerbungsverfahren</h5>
        <p>
          Wir erheben und verarbeiten die Personendaten von Bewerbern zum Zwecke
          der Abwicklung des Bewerbungsverfahrens. Wird ein Anstellungsvertrag
          mit einem Bewerber abgeschlossen, werden die übermittelten Daten zum
          Zwecke der Abwicklung des Beschäftigungsverhältnisses unter Beachtung
          der gesetzlichen Vorschriften gespeichert.{" "}
        </p>
        <p>
          Wird kein Anstellungsvertrag mit dem Bewerber abgeschlossen, so werden
          die Bewerbungsunterlagen sechs Monate nach Bekanntgabe der
          Absageentscheidung gelöscht, sofern einer Löschung keine sonstigen
          berechtigten Interessen der verantwortlichen Stelle entgegenstehen.{" "}
        </p>
        <p>
          Die Verarbeitung von Personendaten für die oben genannten Zwecke
          erfolgt auf der Basis einer Einwilligung, oder aufgrund einem der
          Löschung entgegenstehenden berechtigten Interesse.
        </p>
        <p>
          Wir können mit anderen Arbonia Konzerngesellschaften und weiteren
          dritten datenverarbeitenden Stellen zusammenarbeiten (z.B.
          IT-Dienstleister). Eine allfällige Übermittlung von Personendaten wird
          in Übereinstimmung mit den anwendbaren Datenschutzgesetzen ausgeführt,
          und es existieren angemessene vertragliche, technische und
          organisatorische Massnahmen.
        </p>
        <p>
          <b>Hinweise zu rexx</b>
          <br />
          Wir nutzen Dienste der Firma rexx systems GmbH, Headquarters,
          Süderstrasse 75–79, 20097 Hamburg, Deutschland („rexx“). Die Schweizer
          Niederlassung, die rexx systems Schweiz AG, befindet sich an der
          Sparrenbergstrasse 5 in 8103 Zürich. Nach Eingabe und Übermittlung von
          Personendaten im Bewerbungsverfahren können Ihrer Daten direkt über
          eine verschlüsselte Verbindung auf die Server von rexx gelangen,
          welche die Daten ausschliesslich verschlüsselt auf dem Server im
          Rechenzentrum der Firma Host Europe GmbH (Standort Köln) speichert.
          Sofern dies der Fall ist, werden alle Daten auf Basis des
          SSL-Verfahrens verschlüsselt. Falls Sie sich nach Ihrer Registrierung
          mit den zur Verfügung gestellten Benutzerdaten anmelden, wird auch
          hierfür das SSL-Verschlüsselungsverfahren verwendet.
        </p>
        <p>
          Die Übermittlung der Personendaten wird in Übereinstimmung mit den
          anwendbaren Datenschutzgesetzen ausgeführt, und es existieren
          angemessene vertragliche, technische und organisatorische Massnahmen.
          Sowohl die verantwortliche Stelle als auch der Provider setzen
          technische und organisatorische Sicherheitsmassnahmen ein, um Ihre
          erhobenen Daten gegen zufällige oder vorsätzliche Manipulation,
          Verlust, Zerstörung oder gegen Zugriff unberechtigter Personen zu
          schützen. Unsere Sicherheitsmassnahmen werden entsprechend der
          technologischen Entwicklung fortlaufend verbessert.
        </p>
        <h5>d) Datenverarbeitung zur Zustellung von Medienmitteilungen</h5>
        <p>
          Sie können auf unserer Webseite Medienmitteilungen auf Deutsch oder
          Englisch abonnieren. Wenn Sie sich registrieren, werden die von Ihnen
          angegebenen Daten für den Versand der Medienmitteilung verwendet,
          soweit Sie nicht einer weitergehenden Nutzung zustimmen.
        </p>
        <p>
          Nach der Registrierung erhalten Sie eine Bestätigungs-E-Mail an die
          von Ihnen angegebene E-Mail-Adresse. Erst nach Betätigung des in
          dieser E-Mail enthaltenen Links ist Ihre Anmeldung abgeschlossen. Die
          Verarbeitung erfolgt ausschliesslich auf Grundlage Ihrer Einwilligung.
          Die erteilte Einwilligung zur Speicherung der Daten, der
          E-Mail-Adresse sowie deren Nutzung können Sie jederzeit über die in
          der Medienmitteilung vorgesehene Abmeldemöglichkeit widerrufen. Die
          Rechtmässigkeit der bereits erfolgten Datenverarbeitungsvorgänge
          bleibt vom Widerruf unberührt.
        </p>
        <p>
          Von Ihnen bei der Registrierung angegebenen Daten werden von uns bis
          zu Ihrer Austragung gespeichert und nach der Abbestellung der
          Medienmitteilungen gelöscht. Personendaten, die aufgrund eines anderen
          Zweckes oder einer anderen Einwilligung bei uns gespeichert wurden
          (z.B. E-Mail-Adressen für weitere Funktionen auf der Webseite) bleiben
          hiervon unberührt.
        </p>
        <p>
          Für den Versand der Medienmitteilungen benutzen wir einen
          Subunternehmer in Deutschland, der Ihre Personendaten für den Versand
          von Medienmitteilungen in Deutschland speichert.
        </p>
        <hr />
        <h3>3. Weitergabe von Personendaten an Dritte</h3>
        <p>
          Im Allgemeinen verwenden wir personenbezogene Daten nur für interne
          Geschäftszwecke. Zu diesem Zweck dürfen wir personenbezogene Daten an
          andere Unternehmen der Arbonia-Gruppe übermitteln, und auch andere
          Unternehmen der Arbonia-Gruppe können diese Daten für denselben Zweck
          verwenden. Wir geben Ihre personenbezogenen Daten nicht außerhalb der
          Unternehmen der Arbonia-Gruppe weiter, es sei denn, dies ist für die
          Vertragserfüllung notwendig, gesetzlich zulässig oder Sie haben dem
          zugestimmt.{" "}
        </p>
        <p>
          Wir können jedoch Vereinbarungen mit anderen Unternehmen oder Personen
          ("Auftragsverarbeitern") abschließen, um die Erfüllung bestimmter
          Aufgaben in unserem Namen zu übertragen. Zu diesem Zweck kann es
          notwendig sein, dass wir dem Auftragsverarbeiter Zugriff auf
          personenbezogene Daten gewähren. Unsere Auftragsverarbeiter sind
          verpflichtet, die Vertraulichkeit der übermittelten personenbezogenen
          Daten zu wahren und dürfen die Informationen nicht für Zwecke
          verwenden, die nicht von uns festgelegt wurden.{" "}
        </p>
        <p>
          Jede Übertragung von personenbezogenen Daten erfolgt in
          Übereinstimmung mit den geltenden Datenschutzgesetzen, und wir stellen
          sicher, dass geeignete vertragliche, technische und organisatorische
          Maßnahmen vorhanden sind.
        </p>
        <hr />
        <h3>4. Drittanbieterdienste oder -inhalte auf unserer Website</h3>
        <p>
          Auf unserer Website bieten wir Dienste und/oder Inhalte von
          Drittanbietern an. Wenn Sie diese Drittanbieterdienste nutzen oder
          wenn Drittanbieterinhalte angezeigt werden, erfolgt aus technischen
          Gründen ein Datenaustausch zwischen Ihnen und dem jeweiligen Anbieter.
          Wir kontrollieren weder die Websites noch die Datenschutzpraktiken der
          Drittanbieter, die diese Websites verwalten. Diese
          Datenschutzerklärung gilt daher entsprechend nicht für die verlinkten
          Seiten oder Dienste von Drittanbietern.
        </p>
        <p>
          "Der jeweilige Anbieter der Dienstleistungen oder Inhalte kann auch
          weitere Daten erfassen und für andere Zwecke verarbeiten. Nach bestem
          Wissen haben wir die Dienste und Inhalte von Anbietern so
          konfiguriert, dass entweder die Kommunikation für andere Zwecke als
          die Kommunikation blockiert ist oder die Dienste oder Inhalte nur zum
          Zweck der Anzeige auf unserer Website angezeigt werden, oder
          personenbezogene Daten nur erfasst werden, wenn Sie sich für die
          Nutzung des jeweiligen Dienstes entschieden haben. Da wir jedoch keine
          Kontrolle über die Daten haben, die von Dritten erfasst und
          verarbeitet werden, können wir keine verbindlichen Informationen über
          den Umfang und den Zweck der Verarbeitung Ihrer Daten durch den
          jeweiligen Drittanbieter bereitstellen.
        </p>
        <h5>a) Webseiten-Links</h5>
        <p>
          "Zu Ihrer Information finden Sie auf unserer Website Links, die auf
          Seiten von Drittanbietern verweisen. Da es sich um Websites anderer
          Anbieter handelt, haben wir keinen Einfluss auf deren Inhalt; der
          jeweilige Anbieter ist allein dafür verantwortlich. Für die verlinkten
          Seiten von Drittanbietern gilt diese Datenschutzerklärung entsprechend
          nicht.
        </p>
        <h5>b) Werkzeug</h5>
        <p>
          Unsere Website verwendet die Funktionen von Google Maps und YouTube,
          um die Funktionalität unserer Website zu erhöhen.{" "}
        </p>
        <p>
          <b>Notizen zu Google Maps</b>
          <br />
          "Unsere Website verwendet die Funktionen des Kartendienstes Google
          Maps. Um die Funktionen von Google Maps zu nutzen, ist es notwendig,
          Ihre IP-Adresse zu speichern. Diese Informationen können an einen
          Google-Server in den Vereinigten Staaten übertragen und dort
          gespeichert werden. Wir haben keinen Einfluss auf diese übermittelten
          Daten.
        </p>
        <p>
          Google Maps wird im Interesse der ansprechenden Präsentation unserer
          Online-Angebote und der einfachen Auffindbarkeit an dem auf der
          Website angegebenen Standort verwendet. Dies stellt ein berechtigtes
          Interesse dar.
        </p>
        <p>
          Diese Funktion wird von Google Inc., 1600 Amphitheatre Parkway,
          Mountain View, CA 94043, USA bereitgestellt. Weitere Informationen zur
          Handhabung von Nutzerdaten durch Google finden Sie in der
          Datenschutzerklärung von Google."
        </p>
        <p>
          <b>Notizen zu YouTube</b>
          <br />
          Unsere Website verwendet die Funktionen von YouTube, das von Google
          betrieben wird. Wenn Sie eine unserer Websites mit einem
          YouTube-Plug-in besuchen, wird eine Verbindung zu den Servern von
          YouTube hergestellt. Dadurch wird der YouTube-Server darüber
          informiert, welche unserer Seiten Sie besucht haben. Wenn Sie in Ihrem
          YouTube-Konto angemeldet sind, ermöglichen Sie YouTube, Ihr
          Surfverhalten direkt Ihrem persönlichen Profil zuzuordnen. Dies können
          Sie verhindern, indem Sie sich aus Ihrem YouTube-Konto ausloggen. Wir
          möchten darauf hinweisen, dass wir keine Kenntnis vom Inhalt der
          übermittelten Daten und deren Verwendung durch YouTube haben.
        </p>
        <p>
          YouTube wird im Interesse der ansprechenden Präsentation unserer
          Online-Angebote verwendet. Dies stellt ein berechtigtes Interesse dar.
        </p>
        <p>
          Das Plug-in wird von YouTube LLC, 901 Cherry Ave., San Bruno, CA
          94066, USA betrieben. Weitere Informationen zur Handhabung von
          Nutzerdaten durch YouTube finden Sie in der Datenschutzerklärung von
          YouTube.
        </p>
        <hr />
        <h3>5. Die Löschung von personenbezogenen Daten</h3>
        <p>
          Sofern wir in dieser Datenschutzerklärung keine speziellen
          Speicherfristen festgelegt haben, gelten die folgenden allgemeinen
          Regeln:
        </p>
        <p>
          Im Allgemeinen werden Ihre Daten gelöscht, sobald sie für den
          vorgesehenen Zweck nicht mehr erforderlich sind, wenn Sie Ihre
          Einwilligung widerrufen oder wenn die Nutzung aufgrund eines
          berechtigten Interesses widerrufen wird. Die Daten werden nur über
          diesen Zeitraum hinaus gespeichert, wenn dies aufgrund einer
          gesetzlichen Regelung erforderlich ist, der wir unterliegen (z. B.
          steuer- und handelsrechtliche Vorschriften), oder wenn die Daten für
          die Begründung, Ausübung oder Verteidigung gegen rechtliche Ansprüche
          erforderlich sind.
        </p>
        <hr />
        <h3>6. Sicherheit und Schutz</h3>
        <p>
          Alle Informationen, die Sie uns zusenden, werden auf Servern innerhalb
          der Europäischen Union, des Europäischen Wirtschaftsraums (EWR) und
          der Schweiz gespeichert. Bei der Speicherung dieser Daten legen wir
          großen Wert darauf, ein angemessenes Datenschutzniveau im jeweiligen
          Land sicherzustellen.
        </p>
        <p>
          Wir treffen geeignete technische und organisatorische
          Sicherheitsmaßnahmen, um Ihre Daten vor unbeabsichtigter oder
          vorsätzlicher Manipulation, teilweisem oder vollständigem Verlust,
          Zerstörung oder unbefugtem Zugriff durch Dritte zu schützen. Unsere
          Sicherheitsmaßnahmen werden kontinuierlich verbessert und gemäß den
          neuesten technologischen Entwicklungen angepasst.
        </p>
        <p>
          Wir möchten jedoch darauf hinweisen, dass die Übertragung von Daten im
          Internet (z. B. in der E-Mail-Kommunikation) Sicherheitslücken
          aufweisen kann. Ein vollständiger Schutz von Daten vor dem Zugriff
          durch Dritte ist nicht möglich.
        </p>
        <hr />
        <h3>7. Änderungen der Datenschutzerklärung</h3>
        <p>
          Diese Datenschutzerklärung kann Änderungen unterliegen, beispielsweise
          aufgrund von Gesetzesänderungen oder der Art und Weise der
          Datenverarbeitung. Wir bitten Sie daher, diese Seite regelmäßig zu
          lesen.
        </p>
      </section>
    </div>
  );
}

export default PrivacyPolicyDe;
